var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('span',{staticClass:"tag",class:_vm._f("statusType")(_vm.status)},[_vm._v("\n  "+_vm._s(_vm.challenge && _vm.status === _vm.ONLINE_STATUS.ACTIVE ? "Challenged" : _vm.status)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }